export default __webpack_public_path__ + "static/media/msg-cloud.d0c2cd4e.svg";